const pixelRoundErrorInsensitiveEqual = require('./pixelRoundErrorInsensitiveEqual');

module.exports = array => array
    .filter((item, index, self) => self
        .findIndex(u => pixelRoundErrorInsensitiveEqual(u, item)) === index);
